module.exports = __webpack_public_path__ + "img/faq_btn_bg.9f01a2e0.png";